// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2677":"b3579b0bd508c099","6630":"31a85950eb3a5aec"}[chunkId] + ".css";
};